import Vue, { createApp } from "vue";

import { CreditLogos, FundingAcknowledgment, IconButton, UserExperience } from "@cosmicds/vue-toolkit";
import JwstBrick from "./JwstBrick.vue";
import PlacesGallery from "./PlacesGallery.vue";
import CDSPrivacyPolicy from "./CDSPrivacyPolicy.vue";

import vuetify from "../plugins/vuetify";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { WWTComponent, wwtPinia } from "@wwtelescope/engine-pinia";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBookOpen,
  faTimes,
  faVideo,
  faLocationCrosshairs,
} from "@fortawesome/free-solid-svg-icons";

library.add(faBookOpen);
library.add(faTimes);
library.add(faVideo);
library.add(faLocationCrosshairs);

/** v-hide directive taken from https://www.ryansouthgate.com/2020/01/30/vue-js-v-hide-element-whilst-keeping-occupied-space/ */
// Extract the function out, up here, so I'm not writing it twice
const update = (el: HTMLElement, binding: Vue.DirectiveBinding) => el.style.visibility = (binding.value) ? "hidden" : "";

createApp(JwstBrick, {
  wwtNamespace: "wwt-jwst-brick",
  wtml: {
    nostars: "https://projects.cosmicds.cfa.harvard.edu/cds-website/wwt-content/JWST-Brick-wostars/index.wtml",
    stars: "https://projects.cosmicds.cfa.harvard.edu/cds-website/wwt-content/JWST-Brick-wstars/index.wtml",
    // glimpse: "https://projects.cosmicds.cfa.harvard.edu/cds-website/wwt-content/glimpse_original.wtml",
    zannotation: "https://projects.cosmicds.cfa.harvard.edu/cds-website/wwt-content/JWST-Brick-Annotation/index.wtml",
  },
  bgWtml: "https://projects.cosmicds.cfa.harvard.edu/cds-website/wwt-content/glimpse_original.wtml",
  bgName: "GLIMPSE Original"
})
 
  // Plugins
  .use(wwtPinia)
  .use(vuetify)

  // Directives
  .directive(
    /**
    * Hides an HTML element, keeping the space it would have used if it were visible (css: Visibility)
    */
    "hide", {
      // Run on initialisation (first render) of the directive on the element
      beforeMount(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      },
      // Run on subsequent updates to the value supplied to the directive
      updated(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      }
    })

  // Components
  .component("WorldWideTelescope", WWTComponent)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('icon-button', IconButton)
  .component('credit-logos', CreditLogos)
  .component('funding-acknowledgement', FundingAcknowledgment)
  .component('places-gallery', PlacesGallery)
  .component('user-experience', UserExperience)
  .component('cds-privacy-policy', CDSPrivacyPolicy)

  // Mount
  .mount("#app");
